import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Window, Loading, EmptyState, StatusBadge } from "../../components/VB";

export default function AbsensiSaya() {
  const [items, setItems] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [status, setStatus] = useState("");
  const [view, setView] = useState("bulanan");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/shifts");
      setShifts(data);
    })();
  }, []);

  const load = async () => {
    setLoading(true);
    let params = {};
    const today = new Date();
    if (view === "harian") {
      const t = today.toISOString().slice(0, 10);
      params = { tanggal_mulai: t, tanggal_akhir: t };
    } else if (view === "mingguan") {
      const w = new Date(today); w.setDate(w.getDate() - 7);
      params = { tanggal_mulai: w.toISOString().slice(0, 10), tanggal_akhir: today.toISOString().slice(0, 10) };
    } else if (view === "bulanan") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      params = { tanggal_mulai: first.toISOString().slice(0, 10), tanggal_akhir: today.toISOString().slice(0, 10) };
    }
    if (start) params.tanggal_mulai = start;
    if (end) params.tanggal_akhir = end;
    if (status) params.status = status;
    const { data } = await api.get("/absensi", { params });
    setItems(data);
    setLoading(false);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [view, start, end, status]);

  const shiftName = (id) => shifts.find((s) => s.id === id)?.nama || "-";

  // Summary
  const summary = items.reduce((acc, it) => {
    acc[it.status] = (acc[it.status] || 0) + 1;
    return acc;
  }, {});

  return (
    <Window title="Absensi Saya">
      <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="vb-select" style={{ width: 120 }} value={view} onChange={(e) => setView(e.target.value)} data-testid="view-mode">
          <option value="harian">Harian</option>
          <option value="mingguan">Mingguan</option>
          <option value="bulanan">Bulanan</option>
          <option value="custom">Custom</option>
        </select>
        <input type="date" className="vb-input" style={{ width: 150 }} value={start} onChange={(e) => setStart(e.target.value)} data-testid="abssaya-start" />
        <input type="date" className="vb-input" style={{ width: 150 }} value={end} onChange={(e) => setEnd(e.target.value)} data-testid="abssaya-end" />
        <select className="vb-select" style={{ width: 150 }} value={status} onChange={(e) => setStatus(e.target.value)} data-testid="abssaya-status">
          <option value="">Semua Status</option>
          <option>Hadir</option><option>Tidak Hadir</option><option>Izin</option><option>Sakit</option><option>Terlambat</option>
        </select>
      </div>

      {Object.keys(summary).length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 8, marginBottom: 10 }}>
          {Object.entries(summary).map(([k, v]) => (
            <div key={k} className="vb-statcard">
              <div className="vb-statcard-label">{k}</div>
              <div className="vb-statcard-value">{v}</div>
            </div>
          ))}
        </div>
      )}

      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <table className="vb-table">
          <thead><tr><th>Tanggal</th><th>Shift</th><th>Status</th><th>Masuk</th><th>Pulang</th><th>Catatan</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>{it.tanggal}</td>
                <td>{shiftName(it.shift_id)}</td>
                <td><StatusBadge status={it.status} /></td>
                <td>{it.jam_masuk || "-"}</td>
                <td>{it.jam_pulang || "-"}</td>
                <td>{it.catatan || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Window>
  );
}
